export default __webpack_public_path__ + "static/aiDevZone-0c5adc8702e2d10e6f9bb400ae78a71a.png";